/** saves the Products List
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditproducts
*/
export const SAVE_PRODUCTS_LIST = (state, payload) => {
    state.productsList = payload.products
}

/** saves Accounts Balances
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}

/**
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditproducts%7Bpid%7Dsubproduct%7Bspid%7Dplafond
*/
export const SAVE_PRODUCT_PLAFOND = (state, payload) => {
    state.productPlafond = payload
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_SUBSCRIBE_PRODUCTS_STATES = (state, payload) => {
    state.productPlafond = []
    state.accountsBalances = []
}
